import request from '@/util/request'

const state = {
  paieskaKaina: JSON.parse(sessionStorage.getItem('paieskaKaina')) || [],
  paieskaPavadinimas:
    JSON.parse(sessionStorage.getItem('paieskaPavadinimas')) || [],
  paieskaSelf: JSON.parse(sessionStorage.getItem('paieskaSelf')) || [],
}
const getters = {
  paieskaKaina: state => state.paieskaKaina,
  paieskaSelf: state => state.paieskaSelf,
  paieskaPavadinimas: state => state.paieskaPavadinimas,
}
const actions = {
  loadPaieskaInfo({ commit, dispatch }) {
    return request({
      url: '/paieska/info',
      method: 'post',
    }).then(resp => {
      commit('SET_PAIESKA_KAINA', resp.kaina)
      commit('SET_PAIESKA_PAVADINIMAS', resp.pavadinimas)
      commit('SET_PAIESKA_SELF', resp.apie_save)
    })
  },
}
const mutations = {
  SET_PAIESKA_KAINA(state, payload) {
    state.paieskaKaina = payload
    sessionStorage.setItem('paieskaKaina', JSON.stringify(payload))
  },
  SET_PAIESKA_PAVADINIMAS(state, payload) {
    state.paieskaPavadinimas = payload
    sessionStorage.setItem('paieskaPavadinimas', JSON.stringify(payload))
  },
  SET_PAIESKA_SELF(state, payload) {
    state.paieskaSelf = payload
    sessionStorage.setItem('paieskaSelf', JSON.stringify(payload))
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
